import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Grid from "@mui/material/Grid";
import CircularProgress from '@mui/material/CircularProgress';
import { namedColor, transparentize } from 'Chart/ChartUtils';
import DetectorsOverview from '../tables/DetectorsOverview';
import { detectorModelCodes } from 'modules/globals';
import ReactSpeedometer from "react-d3-speedometer";
import BarTimeValue from '../Charts/BarTimeValue';
import config from '../../../../config';
import { detectorNames } from 'modules/globals';
import Icon from "@mui/material/Icon";
import Tooltip from '@mui/material/Tooltip';
import MDBox from "components/MDBox";
import Steps from "layouts/pages/widgets/components/Steps";
import { DIAGRAM_COLORS } from 'diagrammColors';

const DetectorComp = ({ params }) => {
    const { t } = useTranslation();
    const [error, setError] = useState(false)
    const [noIntersectionData, setNoIntersectionData] = useState(false)
    const [noRouteData, setNoRouteData] = useState(false)
    const [noDetData, setNoDetData] = useState(false)

    const [chartData, setChartData] = useState()
    const [chartDataPerIntersection, setChartDataPerIntersection] = useState()
    const [chartDataPerRoute, setChartDataPerRoute] = useState()
    const [chartDataPerDet, setChartDataPerDet] = useState()
    const [detectorStats, setDetectorStats] = useState()

    const [validityGause, setValidityGause] = useState()

    const getNameById = (id) => {
        const item = params.selectedDetectors.find(item => item.id === id);
        return item ? item.name : null; // Return name if found, otherwise null
    };

    const flagsTitle = {
        "1": t("dataQuality.flags.1.title"),
        "2": t("dataQuality.flags.2.title"),
        "3": t("dataQuality.flags.3.title"),
        "4": t("dataQuality.flags.4.title"),
        "5": t("dataQuality.flags.5.title"),
        "6": t("dataQuality.flags.6.title"),
    }
    const flagsTooltip = {
        "1": t("dataQuality.flags.1.tooltip"),
        "2": t("dataQuality.flags.2.tooltip"),
        "3": t("dataQuality.flags.3.tooltip"),
        "4": t("dataQuality.flags.4.tooltip"),
        "5": t("dataQuality.flags.5.tooltip"),
        "6": t("dataQuality.flags.6.tooltip"),
    }
    const validityLocationKey = {
        Intersections: "dataQuality.detectorComp.validityPerIntersection",
        Routes: "dataQuality.detectorComp.validityPerRoute",
        Detectors: "dataQuality.detectorComp.validityPerDetector",
    }
    useEffect(() => {
        async function fetchData() {
            try {
                let getUrl = "";
                if (params.detector === "all") {
                    getUrl = config.ENDPOINTS_URL + `/rpc/th_completeness_per_provider_materialized_dynamic?start_time=${params.dates.from}&end_time=${params.dates.to}&&provider_filter={Siemens,SCAE,Swarco}`
                } else if (params.detector === "yunex") {
                    getUrl = config.ENDPOINTS_URL + `/rpc/th_completeness_per_provider_materialized_dynamic?start_time=${params.dates.from}&end_time=${params.dates.to}&&provider_filter={Siemens}`
                } else if (params.detector === "scae") {
                    getUrl = config.ENDPOINTS_URL + `/rpc/th_completeness_per_provider_materialized_dynamic?start_time=${params.dates.from}&end_time=${params.dates.to}&&provider_filter={SCAE}`
                } else {
                    getUrl = config.ENDPOINTS_URL + `/rpc/th_completeness_per_provider_materialized_dynamic?start_time=${params.dates.from}&end_time=${params.dates.to}&&provider_filter={Swarco}`
                }
                const response = await axios(getUrl, {
                    headers: {
                        "Accept-Profile": "detectors"
                    }
                });
                if (params.detector === "all") {
                    const Siemens = response.data.Siemens.map((item) => ({
                        x: new Date(item.ets).toLocaleString('en-GB'), // Format date to be readable
                        y: item.completeness,
                    }));

                    const SCAE = response.data.SCAE.map((item) => ({
                        x: new Date(item.ets).toLocaleString('en-GB'),
                        y: item.completeness,
                    }));
                    const Swarco = response.data.Swarco.map((item) => ({
                        x: new Date(item.ets).toLocaleString('en-GB'), // Format date to be readable
                        y: item.completeness,
                    }));
                    const chartD = {
                        datasets: [
                            {
                                label: "SIEMENS",
                                data: Siemens,
                                borderWidth: 0, // Removes the connecting line                            
                                backgroundColor: DIAGRAM_COLORS[0], // Point fill color
                                tension: 0.4, // Line smoothing
                            },
                            {
                                label: "SCAE",
                                data: SCAE,
                                borderWidth: 0, // Removes the connecting line                            
                                backgroundColor: DIAGRAM_COLORS[1], // Point fill color
                                tension: 0.4, // Line smoothing
                            },
                            {
                                label: "SWARCO",
                                data: Swarco,
                                borderWidth: 0, // Removes the connecting line                            
                                backgroundColor: DIAGRAM_COLORS[2], // Point fill color
                                tension: 0.4, // Line smoothing
                            }
                        ],
                    };
                    setChartData(chartD)

                } else if (params.detector === "yunex") {
                    const Siemens = response.data.Siemens.map((item) => ({
                        x: new Date(item.ets).toLocaleString('en-GB'), // Format date to be readable
                        y: item.completeness,
                    }));
                    const chartD = {
                        datasets: [
                            {
                                label: "SIEMENS",
                                data: Siemens,
                                borderWidth: 0, // Removes the connecting line                            
                                backgroundColor: DIAGRAM_COLORS[0], // Point fill color
                                tension: 0.4, // Line smoothing
                            }
                        ]
                    };
                    setChartData(chartD)
                } else if (params.detector === "scae") {
                    const SCAE = response.data.SCAE.map((item) => ({
                        x: new Date(item.ets).toLocaleString('en-GB'), // Format date to be readable
                        y: item.completeness,
                    }));
                    const chartD = {
                        datasets: [
                            {
                                label: "SCAE",
                                data: SCAE,
                                borderWidth: 0, // Removes the connecting line                            
                                backgroundColor: DIAGRAM_COLORS[0], // Point fill color
                                tension: 0.4, // Line smoothing
                            }
                        ]
                    };
                    setChartData(chartD)
                } else {
                    const Swarco = response.data.Swarco.map((item) => ({
                        x: new Date(item.ets).toLocaleString('en-GB'), // Format date to be readable
                        y: item.completeness,
                    }));
                    const chartD = {
                        datasets: [
                            {
                                label: "SWARCO",
                                data: Swarco,
                                borderWidth: 0, // Removes the connecting line                            
                                backgroundColor: DIAGRAM_COLORS[0], // Point fill color
                                tension: 0.4, // Line smoothing
                            }
                        ]
                    };
                    setChartData(chartD)
                }
            } catch (err) {
                console.log(err)
                setError(true)
            }
        }
        async function fetchPerIntersection() {
            let getUrl = "";
            if (params.detector === "yunex") {
                getUrl = config.ENDPOINTS_URL + `/rpc/th_completeness_per_intersection_materialized_dynamic?in_start_time=${params.dates.from}&in_end_time=${params.dates.to}&in_detector_model_id=2&in_intersection_ids={`
            } else if (params.detector === "scae") {
                getUrl = config.ENDPOINTS_URL + `/rpc/th_completeness_per_intersection_materialized_dynamic?in_start_time=${params.dates.from}&in_end_time=${params.dates.to}&in_detector_model_id=1&in_intersection_ids={`
            } else {
                getUrl = config.ENDPOINTS_URL + `/rpc/th_completeness_per_intersection_materialized_dynamic?in_start_time=${params.dates.from}&in_end_time=${params.dates.to}&in_detector_model_id=3&in_intersection_ids={`
            }
            params.selectedDetectors.map((detector) => {
                getUrl = getUrl + detector.id.toString() + ','
            })
            let newUrl = getUrl.substring(0, getUrl.length - 1);

            newUrl = newUrl + "}";
            let tempDataVals
            try {
                const response = await axios(newUrl, {
                    headers: {
                        "Accept-Profile": "detectors"
                    }
                });
                console.log(response.data)
                if (!response.data) {
                    setNoIntersectionData(true)
                } else {
                    setNoIntersectionData(false)
                    let dataset = [];
                    params.selectedDetectors.map((detector, key) => {
                        tempDataVals = response.data[detector.id].map((item) => ({
                            x: new Date(item.ets).toLocaleString('en-GB'), // Format date to be readable
                            y: item.completeness,
                        }));
                        const dsColor = namedColor(key);
                        dataset.push({
                            label: getNameById(detector.id),
                            data: tempDataVals,
                            backgroundColor: DIAGRAM_COLORS[0],
                            borderWidth: 0, // Removes the connecting line                            
                            tension: 0.4, // Line smoothing
                        })
                    })
                    const chartD = {
                        datasets: dataset
                    }
                    setChartDataPerIntersection(chartD)
                }
            } catch (err) {
                console.log(err)
            }

        }
        async function fetchPerRoute() {
            let getUrl = "";
            if (params.detector === "yunex") {
                getUrl = config.ENDPOINTS_URL + `/rpc/th_completeness_per_route_dynamic_materialized_dynamic?in_start_time=${params.dates.from}&in_end_time=${params.dates.to}&in_detector_model_id=2&in_route_ids={`
            } else if (params.detector === "scae") {
                getUrl = config.ENDPOINTS_URL + `/rpc/th_completeness_per_route_dynamic_materialized_dynamic?in_start_time=${params.dates.from}&in_end_time=${params.dates.to}&in_detector_model_id=1&in_route_ids={`
            } else {
                getUrl = config.ENDPOINTS_URL + `/rpc/th_completeness_per_route_dynamic_materialized_dynamic?in_start_time=${params.dates.from}&in_end_time=${params.dates.to}&in_detector_model_id=3&in_route_ids={`
            }
            params.selectedDetectors.map((detector) => {
                getUrl = getUrl + detector.id.toString() + ','
            })
            let newUrl = getUrl.substring(0, getUrl.length - 1);

            newUrl = newUrl + "}";
            let tempDataVals
            try {
                const response = await axios(newUrl, {
                    headers: {
                        "Accept-Profile": "detectors"
                    }
                });
                if (!response.data) {
                    setNoRouteData(true)
                } else {
                    setNoRouteData(false)
                    let dataset = [];
                    params.selectedDetectors.map((detector, key) => {
                        tempDataVals = response.data[detector.id].map((item) => ({
                            x: new Date(item.ets).toLocaleString('en-GB'), // Format date to be readable
                            y: item.completeness,
                        }));
                        const dsColor = namedColor(key);
                        dataset.push({
                            label: getNameById(detector.id),
                            data: tempDataVals,
                            backgroundColor: DIAGRAM_COLORS[0],
                            borderWidth: 0, // Removes the connecting line                            
                            tension: 0.4, // Line smoothing
                        })
                    })
                    const chartD = {
                        datasets: dataset
                    }
                    setChartDataPerRoute(chartD)
                }
            } catch (err) {
                console.log(err)
            }

        }
        async function fetchPerDet() {
            let getUrl = "";
            if (params.detector === "yunex") {
                getUrl = config.ENDPOINTS_URL + `/rpc/th_completeness_per_detector_materialized_dynamic?in_start_time=${params.dates.from}&in_end_time=${params.dates.to}&in_detector_model_id=2&in_detector_ids={`
            } else if (params.detector === "scae") {
                getUrl = config.ENDPOINTS_URL + `/rpc/th_completeness_per_detector_materialized_dynamic?in_start_time=${params.dates.from}&in_end_time=${params.dates.to}&in_detector_model_id=1&in_detector_ids={`
            } else {
                getUrl = config.ENDPOINTS_URL + `/rpc/th_completeness_per_detector_materialized_dynamic?in_start_time=${params.dates.from}&in_end_time=${params.dates.to}&in_detector_model_id=3&in_detector_ids={`
            }
            params.selectedDetectors.map((detector) => {
                getUrl = getUrl + detector.id.toString() + ','
            })
            let newUrl = getUrl.substring(0, getUrl.length - 1);

            newUrl = newUrl + "}";
            let tempDataVals
            try {
                const response = await axios(newUrl, {
                    headers: {
                        "Accept-Profile": "detectors"
                    }
                });
                if (!response.data) {
                    setNoDetData(true)
                } else {
                    setNoDetData(false)
                    let dataset = [];
                    params.selectedDetectors.map((detector, key) => {
                        tempDataVals = response.data[detector.id].map((item) => ({
                            x: new Date(item.ets).toLocaleString('en-GB'), // Format date to be readable
                            y: item.completeness,
                        }));
                        const dsColor = namedColor(key);
                        dataset.push({
                            label: getNameById(detector.id),
                            data: tempDataVals,
                            backgroundColor: DIAGRAM_COLORS[0],
                            borderWidth: 0, // Removes the connecting line                            
                            tension: 0.4, // Line smoothing
                        })
                    })
                    const chartD = {
                        datasets: dataset
                    }
                    setChartDataPerDet(chartD)
                }
            } catch (err) {
                console.log(err)
            }

        }

        async function fetchValidityData(detectorModel, validityUrl, idsUrl) {
            try {
                let getUrl = "";
                const modelCode = detectorModelCodes[detectorModel];
                getUrl = config.ENDPOINTS_URL + `/rpc/${validityUrl}?in_start_timestamp=${params.dates.from}&in_end_timestamp=${params.dates.to}&in_detector_model_id=${modelCode}&${idsUrl}=`
                params.selectedDetectors.map((detector) => {
                    getUrl = getUrl + detector.id.toString() + ','
                })
                let newUrl = getUrl.substring(0, getUrl.length - 1);

                console.log(newUrl)
                const response = await axios(newUrl, {
                    headers: {
                        "Accept-Profile": "detectors"
                    }
                });
                setValidityGause(response.data)
            } catch (err) {
                console.log(err)
            }
        }

        async function detectorStatistics() {
            try {
                let newUrl = config.ENDPOINTS_URL + `/detector_statistics`;
                const response = await axios(newUrl, {
                    headers: {
                        "Accept-Profile": "detectors"
                    }
                });
                const filtered = response.data.filter((item) => (
                    item.id === params.selectedDetectors[0].id
                ))
                console.log(filtered)
                setDetectorStats(filtered)
            } catch (err) {
                console.log(err)
            }
        }

        fetchData();
        if (params.detector !== "all" && params.location === "Intersections" && params.selectedDetectors.length > 0) {
            fetchPerIntersection();
            fetchValidityData(params.detector, "th_validity_per_intersection_materialized", "in_intersection_ids")
        }
        if (params.detector !== "all" && params.location === "Routes" && params.selectedDetectors.length > 0) {
            fetchPerRoute();
            fetchValidityData(params.detector, "th_validity_per_route_materialized", "in_route_ids");
        }
        if (params.detector !== "all" && params.location === "Detectors" && params.selectedDetectors.length > 0) {
            fetchPerDet();
            fetchValidityData(params.detector, "th_validity_per_detector_materialized", "in_detector_ids");
            detectorStatistics();
        }
    }, [params])
    return (
        <Grid container={true} p={2}>
            {
                params.detector !== "all" && params.location === "Intersections" && params.selectedDetectors.length > 0 &&
                <div className='rawContainerDiagrams'>
                    <div className='diagrammHeadTitle'>{t("dataQuality.metrics.completeness")} {detectorNames[params.detector]}</div>
                    {chartDataPerIntersection ? <div className='detectorDiagramsContainer'><BarTimeValue chartData={chartDataPerIntersection} title="" /> </div> : <div className='rawContainerCenteredH'>{noIntersectionData ? <span>{t("dataQuality.detectorComp.noDataForCombo")}</span> : <CircularProgress />}</div>}
                </div>
            }
            {
                params.detector !== "all" && params.location === "Routes" && params.selectedDetectors.length > 0 &&
                <div className='rawContainerDiagrams'>
                    <div className='diagrammHeadTitle'>{t("dataQuality.metrics.completeness")} {detectorNames[params.detector]}</div>
                    {chartDataPerRoute ? <div className='detectorDiagramsContainer'><BarTimeValue chartData={chartDataPerRoute} title="" /></div> : <div className='rawContainerCenteredH'>{noRouteData ? <span>{t("dataQuality.detectorComp.noDataForCombo")}</span> : <CircularProgress />}</div>}
                </div>
            }
            {
                params.detector !== "all" && params.location === "Detectors" && params.selectedDetectors.length > 0 &&
                <div className='rawContainerDiagrams'>
                    <div className='diagrammHeadTitle'>{t("dataQuality.metrics.completeness")} {detectorNames[params.detector]}</div>
                    {chartDataPerDet ? <div className='detectorDiagramsContainer'><BarTimeValue chartData={chartDataPerDet} title="" /> </div> : <div className='rawContainerCenteredH'>{noDetData ? <span>{t("dataQuality.detectorComp.noDataForCombo")}</span> : <CircularProgress />}</div>}
                </div>
            }

            {
                (params.detector !== "all" && params.location !== "Network" && params.selectedDetectors.length > 0) &&
                <div className='rawContainerDiagrams'>
                    <div className='diagrammHeadTitle'>{t(validityLocationKey[params.location] || "dataQuality.metrics.validity")}</div>
                    {(validityGause && validityGause.length > 0)
                        ? <div className='rawContainerDiagrams'>
                            {
                                validityGause.map((item, key) => (
                                    <MDBox key={key}>
                                        <Steps title={flagsTitle[String(item.flag)]} value={item.percentage_invalid.toFixed(2)} symbol="%" />
                                    </MDBox>
                                ))
                            }
                        </div>
                        : (validityGause && validityGause.length === 0) ? <span>{t("dataQuality.detectorComp.noData")}</span> : <div className='rawContainerCenteredH'><CircularProgress /></div>}
                </div>
            }
            {/*}
            <div className='rawContainerDiagrams'>
                <div className='diagrammHeadTitle'>Accuracy per Detector</div>
                <div className="percentage-container">
                    <span className="percentage-value">{5}%</span>
                    <span className="percentage-label">The value from the detectors deviated by approximately 5% from the ground truth value (TomTom data) at that specific time interval</span>
                </div>
            </div>
            */}

        </Grid>
    );
};

export default DetectorComp;

/*
            {
                (params.location === "Detectors" && detectorStats)
                    ? <div className='rawContainerDiagrams'>
                        <div className='diagrammHeadTitle'>Detector Statistics</div>
                        <div className='rawContainerDiagrams'>
                            <div className="containerDetStats">
                                <span className='containerDetStatsTitle'>General Stats</span>
                                <div className='containerDetStatsBody'>
                                    <div className='statrow'>
                                        <span className="valueDetStats">{detectorStats[0].mean}%</span>
                                        <span className="labelDetStats">Mean</span>
                                    </div>
                                    <div className='statrow'>
                                        <span className="valueDetStats">{detectorStats[0].percentage_of_zero}%</span>
                                        <span className="labelDetStats">Median</span>
                                    </div>
                                    <div className='statrow'>
                                        <span className="valueDetStats">{detectorStats[0].iqr}%</span>
                                        <span className="labelDetStats">Iqr</span>
                                    </div>
                                </div>
                            </div>
                            <div className="containerDetStats">
                                <span className='containerDetStatsTitle'>Percentages of completeness</span>
                                <div className='containerDetStatsBody'>
                                    <div className='statrow'>
                                        <span className="valueDetStats">{detectorStats[0].percentage_of_completeness}%</span>
                                        <span className="labelDetStats">Completeness</span>
                                    </div>
                                    <div className='statrow'>
                                        <span className="valueDetStats">{detectorStats[0].percentage_of_zero}%</span>
                                        <span className="labelDetStats">zeros</span>
                                    </div>
                                    <div className='statrow'>
                                        <span className="valueDetStats">{detectorStats[0].percentage_of_invalid}%</span>
                                        <span className="labelDetStats">Invalid</span>
                                    </div>
                                </div>
                            </div>
                            <div className="containerDetStats">
                                <span className='containerDetStatsTitle'>Percentages of Flags</span>
                                <div className='containerDetStatsBody'>
                                    <div className='statrow'>
                                        <span className="valueDetStats">{detectorStats[0].percentage_flag_1}%</span>
                                        <span className="labelDetStats">Flag 1</span>
                                    </div>
                                    <div className='statrow'>
                                        <span className="valueDetStats">{detectorStats[0].percentage_flag_2}%</span>
                                        <span className="labelDetStats">Flag 2</span>
                                    </div>
                                    <div className='statrow'>
                                        <span className="valueDetStats">{detectorStats[0].percentage_flag_3}%</span>
                                        <span className="labelDetStats">Flag 3</span>
                                    </div>
                                    <div className='statrow'>
                                        <span className="valueDetStats">{detectorStats[0].percentage_flag_4}%</span>
                                        <span className="labelDetStats">Flag 4</span>
                                    </div>
                                    <div className='statrow'>
                                        <span className="valueDetStats">{detectorStats[0].percentage_flag_5}%</span>
                                        <span className="labelDetStats">Flag 5</span>
                                    </div>
                                    <div className='statrow'>
                                        <span className="valueDetStats">{detectorStats[0].percentage_flag_6}%</span>
                                        <span className="labelDetStats">Flag 6</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : params.location !== "Detectors" ? <></> : <div className='rawContainerCenteredH'><CircularProgress /></div>
            }


*/